export default __webpack_public_path__ + "static/media/SessionReferralCardWide.823895cd.png";